// extracted by mini-css-extract-plugin
export var dropdown = "_tz-0";
export var imageWrapper = "_tz-3";
export var itemNameContainer = "_tz-1";
export var productImage = "_tz-2";
export var spinnerWrapper = "_tz-4";